import { Component, OnInit } from '@angular/core';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import * as moment  from 'moment';
import { TransportService } from 'src/app/services/Transport/transport.service';

@Component({
  selector: 'app-route-details',
  templateUrl: './route-details.component.html',
  styleUrls: ['./route-details.component.css']
})
export class RouteDetailsComponent implements OnInit {

  constructor(private transportService:TransportService,private spinnerService: Ng4LoadingSpinnerService,private lookupService:LookupService,public globalHelper :GlobalHelper) { }


  RouteDetailsModel = {       
    RouteID: 0,
    RouteName: '',
    IsActive: true

};

RouteDetailsList = [];

Submitted = false;
Action = 'Add';
msg = '';
Clear() {
  this.RouteDetailsModel = {       
    RouteID: 0,
    RouteName: '',
    IsActive: true

};
    this.Submitted = false;
}


loading = false;
SaveRoute(valid) {
    this.Submitted = true;
    if (valid) {               
    this.loading = true;
    this.transportService.SaveRoute(JSON.stringify(this.RouteDetailsModel)).subscribe( (response)=> {
        setTimeout( () =>{
                this.loading = false;
            }, 10);
           
            this.GetAllRoutes();
            this.globalHelper.CheckActionStatus(response);
            this.Clear();
    });
        }

};



GetAllRoutes() {
    this.spinnerService.show();
    this.transportService.SearchAllRoute().subscribe( (data)=> {
        this.RouteDetailsList = data.RouteDetailsList;
        this.spinnerService.hide();
    });


};



Edit(obj) {      
    this.RouteDetailsModel.RouteID = obj.RouteID;
    this.RouteDetailsModel.RouteName = obj.RouteName;
   
};



RouteMarkActive(item) {

    
    this.RouteDetailsModel.RouteID = item.RouteID;
    this.RouteDetailsModel.IsActive = item.IsActive == true ? false : true;

    this.transportService.RouteMarkActive(JSON.stringify(this.RouteDetailsModel)).subscribe( (data)=> {
        this.GetAllRoutes();
        this.Clear();

        this.globalHelper.CheckActionStatus(data);
       
      


    });
}
  ngOnInit() {
    this.GetAllRoutes();
  }

}
